import React from "react";

const CustomCell = ({ dataItem, field }) => {
  return (
    <td className="custom-cell">
      <span className="cell-value">{dataItem[field]}</span>

      <div className="cell-row">
        <div className="field-group">
          <label>Rating</label>
          <input type="number" min="1" max="5" />
        </div>

        <div className="field-group">
          <label>Comment</label>
          <input type="text" placeholder="Add comment" />
        </div>
      </div>
    </td>
  );
};

export default CustomCell;
